import { defineMessages } from 'react-intl';

export default defineMessages({
  needHelpTooltipTitle: {
    id: 'components.needHelp.tooltip.title',
    defaultMessage: 'Need help ?',
  },
});
